<template>
  <div class="carousel">
    <ul :style="getScrollStyle" id="carouseWrap" :class="{'animated': isAnimate}">
      <li v-for="(item, index) in currentList" :key="index">{{keyName ? item[keyName]: item}}</li>
    </ul>
  </div>
</template>
<script>
import {
  mapGetters,
  mapActions
} from 'vuex';

import util from 'libs/util'

export default {
  props: {
    delay: {
      type: [Number],
      default: 5000
    },
    keyName: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      default () {
        return []
      }
    }
  },
  watch: {
    list(val, newVal) {
      const currentList = [...val];
      if (val && val.length > 0) {
        currentList.unshift(val[val.length - 1]);
        this.currentList = currentList;
        this.$nextTick(() => {
          this.getItemHeight();
        })
        this.init();
      }
    }
  },
  data() {
    return {
      currentList: [],
      isAnimate: 1,
      currentIndex: 1,
      itemHeight: 0
    }
  },
  computed: {
    getScrollStyle() {
      const currentIndex = this.currentIndex;
      const transformY = -util.math.Mul(currentIndex, this.itemHeight, 2);
      const styles = {
        transform: `translateY(${transformY}px)`
      }
      return styles;
    }
  },
  mounted() {
    this.getItemHeight();
    this.init();
  },
  methods: {
    getItemHeight() {
      let dom = document.querySelector('#carouseWrap li');
      dom && (this.itemHeight = dom.getBoundingClientRect().height);
    },
    init() {
      this.currentIndex = 1;
      this.autoPlay();
    },
    autoPlay() {
      let length = this.currentList.length;
      this.timer && clearInterval(this.timer);
      this.timer = setInterval(() => {
        if (this.currentIndex >= length - 1) {
          this.isAnimate = 0;
          this.currentIndex = 0;
          setTimeout(() => {
            this.currentIndex = 1;
            this.isAnimate = 1;
          }, 10)
        } else {
          this.isAnimate = 1;
          this.currentIndex++;
        }
      }, this.delay)
    }
  }
}
</script>
<style lang="less">
@import "~styles/var";
@import "~styles/mixin";
.carousel {
  height: 100%;
  overflow: hidden;
  ul {
    li {
      white-space: normal;
    }
    &.animated {
      transition: transform ease .5s;
    }
  }
}
</style>